import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function fetchBadges() {
  const token = getToken();
  const res = await axios.get(`${API}/cabin/badges`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  // Backend may return { badges: [...] } or plain array
  const badges = Array.isArray(res.data) ? res.data : (res.data?.badges ?? res.data);
  return badges;
}

export function useBadges() {
  return useQuery({
    queryKey: ['cabin', 'badges'],
    queryFn: fetchBadges,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: typeof window !== 'undefined' && !!getToken(),
  });
}
